/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Explore (C) Copyright IBM Corp. 2018
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */


class VisTitleFetcherFeature {

	constructor (widgetApi, dashboardApi) {
		this.widgetApi = widgetApi;
		this.dashboardApi = dashboardApi;
		this._initialRequestDone = false;

		this._widgetApiHandlers = {
			_onRenderStart: this.widgetApi.on('renderStart', this._onRenderStart.bind(this)),
			_onChangeDefinition: this.widgetApi.on('visevent:changeDefinition', this._triggerTitleUpdate.bind(this))
		};

		this._dashboardApiHandlers = {
			_onShapingModelChange: this.dashboardApi.on('shapingmodel:changed', this._onShapingModelChange, this)
		};
	}

	destroy() {
		this._deregisterAllListeners();
		return Promise.resolve(true);
	}

	_deregisterAllListeners() {
		this._deregisterOnRenderStartListener();

		if (this._widgetApiHandlers._onChangeDefinition) {
			this._widgetApiHandlers._onChangeDefinition.remove();
			this._widgetApiHandlers._onChangeDefinition = null;
		}
		if(this._dashboardApiHandlers._onShapingModelChange) {
			this._dashboardApiHandlers._onShapingModelChange.remove();
			this._dashboardApiHandlers._onShapingModelChange = null;
		}
	}

	_deregisterOnRenderStartListener() {
		if (this._widgetApiHandlers._onRenderStart) {
			this._widgetApiHandlers._onRenderStart.remove();
			this._widgetApiHandlers._onRenderStart = null;
		}
	}

	/**
	 * Handler called on widget render start
	 * Only trigger title update for initial render when title is not already set in the LW model
	 * This covers 2 cases:
	 * 	- setting title in Live widget preview in comet card
	 *  - add LW from dashboard into explore
	 * For all the other cases, title is set in the widget spec before its loaded
	 * or title is set on data slot change (already handled in Live widget)
	 */
	_onRenderStart() {
		let visApi = this.widgetApi.getVisApi();
		if( visApi && !this._initialRequestDone ) {
			this._initialRequestDone = true;
			this._deregisterOnRenderStartListener();
			if (!visApi.getTitle() ) {
				this.widgetApi.updateTitle && this.widgetApi.updateTitle();
			}
		}
	}

	/**
	 * Handler is called on dashboard api shaping model change
	 * Idea is to only trigger title update when the no refresh flag is false (i.e. needs to refresh)
	 * eg. Change the name of a context calculation
	 * 1) The calculation is projected in the visualization -> title update is called in widgetApi
	 * 2) The calculation is not projected in the visualization -> title update is not called
	 * shaping model change can trigger onRenderStart above but it is handled here
	 * because there can exist a title already, a new title needs to replace the old one.
	 *
	 * @param {object} [payload] - event payload
	 * @param {boolean} [payload.noRefresh] - boolean to signal whether widget needs to be refreshed hence the title needs to update
	 */
	_onShapingModelChange(payload){
		if(payload && !payload.noRefresh){
			this._triggerTitleUpdate();
		}
	}

	_triggerTitleUpdate() {
		this.widgetApi.updateTitle && this.widgetApi.updateTitle();
	}

}
export default VisTitleFetcherFeature;



// WEBPACK FOOTER //
// ./src/js/lib/@waca/vis-title-fetcher/src/js/VisTitleFetcherFeature.js